import React, { useEffect, useState } from "react";
import "./ticketConverterModal.css";
import { useDispatch, useSelector } from "react-redux";
import { ticketsAPI } from "../../../services/api";
import { fetchWalletBalance } from "../../../features/wallet/store/walletSlice";
import ModalBackground from "../../../shared/components/ModalBackground";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../../i18n/format";

export default function TicketConverterModal({ onClose }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const datumCoins = useSelector((state) => state.wallet.datumCoins);
  const [visible, setVisible] = useState(false);
  const [tickets, setTickets] = useState(0);
  const [ticketPrice, setTicketPrice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // Max tickets user can afford; updates whenever coins or price changes
  const maxTickets = ticketPrice && ticketPrice > 0
    ? Math.floor(datumCoins / ticketPrice)
    : 0;

  useEffect(() => {
    setVisible(true);
    fetchExchangeRate();
  }, []);

  // Clamp selected tickets if balance decreased or price loaded
  useEffect(() => {
    if (tickets > maxTickets) setTickets(maxTickets);
  }, [maxTickets]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchExchangeRate = async () => {
    try {
      const data = await ticketsAPI.getExchangeRate();
      setTicketPrice(data.coinsPerTicket);
    } catch (error) {
      console.error("Failed to fetch exchange rate:", error);
      setTicketPrice(null);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (delta) => {
    if (tickets == 0 && delta == -1) {
      // audioRef?.current?.play('btnMisclick')
    } else if (tickets == maxTickets && delta == 1) {
      // audioRef?.current?.play('btnMisclick')
    } else {
      // audioRef?.current?.play('btnClick')
    }
    setTickets((prev) => Math.max(0, Math.min(maxTickets, prev + delta)));
  };

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  const handleConvert = async () => {
    if (tickets === 0 || !ticketPrice || submitting) return;
    setSubmitting(true);

    try {
      await ticketsAPI.convert(tickets);
      dispatch(fetchWalletBalance());
      handleClose();
    } catch (error) {
      console.error("Exchange failed:", error);
      const msg = error?.response?.data?.message || error?.response?.data?.error
        || t("tickets.exchange_failed", "Exchange failed. Please try again.");
      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="purchase-modal-overlay" onClick={handleClose}>
      <div
        className={`purchase-card ${visible ? "visible" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`purchase-modal-sheet-ticket ${visible ? "visible" : ""}`}>
          <div className="purchase-modal-header" style={{ position: 'relative' }}>
            <ModalBackground />
            <h2 className="purchase-modal-title" style={{ position: 'relative', zIndex: 1 }}>{t("tickets.converter_title", "Convertation")}</h2>
            <img
              className="purchase-modal-close"
              src="/close.png"
              alt={t("common.close", "Close")}
              onClick={handleClose}
              style={{ position: 'absolute', zIndex: 1 }}
            />
          </div>

          <div className="ticket-content">
            <p className="ticket-label">{t("tickets.you_get", "You will get tickets:")}</p>
            <div className="ticket-counter">
              <button
                className={`counter-btn-minus ${tickets === 0 ? "disabled" : ""}`}
                onClick={() => handleChange(-1)}
                // disabled={tickets === 0}
              />
              <div className="counter-icons-div">
                <img src="/ticket_icon.png" alt={t("reward.ticket", "Ticket")} className="ticket-img" />
                <span className="ticket-amount">{tickets}</span>
              </div>
              <button
                className={`counter-btn-plus ${tickets >= maxTickets ? "disabled" : ""}`}
                onClick={() => handleChange(1)}
                // disabled={tickets >= maxTickets}
              />
            </div>

            <p className="ticket-label">{t("tickets.you_spend", "You will spend coins:")}</p>
            <div className="ticket-cost">
              <img src="/coin_icon.png" alt={t("common.coins", "Coins")} />
              <span>
                {loading || ticketPrice === null
                  ? t("common.loading", "Loading…")
                  : formatNumber(tickets * ticketPrice)}
              </span>
            </div>
            {false && !loading && ticketPrice !== null && (
              <p style={{ fontSize: 13, color: '#9995ca', marginBottom: 8 }}>
                Available: {datumCoins.toLocaleString()} coins
                {maxTickets > 0 ? ` (max ${maxTickets} tickets)` : ' — not enough coins'}
              </p>
            )}

            <button
              className="app-btn app-btn--green"
              disabled={tickets === 0 || loading || ticketPrice === null || submitting}
              onClick={handleConvert}
            >
              {submitting
                ? t("tickets.converting", "Converting…")
                : tickets === 0
                ? t("tickets.price", "Price for convertation: {{price}} gold", { price: ticketPrice })
                : t("tickets.exchange", "Exchange & continue")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
